var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { flattenArray } from "@domains/utils/filter";
import { EMFSchemesPlanType2, MFSchemesPlanTypes, } from "@domains/features/Markets/MutualFunds/entities/MFCommon";
import { EInvestmentType } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFundConstant";
var divFrequencyMapper = function (divfreq, trxType) {
    return divfreq.map(function (z) {
        var _a;
        var index = 0;
        var dpIndex = z.transactionModeList.findIndex(function (item) { return item.transactionMode === "DP"; });
        if (dpIndex > 0) {
            index = dpIndex;
        }
        var lumpsumFlag = false, redeemFlag = false, sipFlag = false, swpFlag = false, stpFlag = false, switchFlag = false, transactionMode = z.transactionModeList[index].transactionMode, sipFrequency = [], sipData = undefined, swpData = undefined, stpData = undefined, redeemData = undefined, lumpsumData = undefined, switchData = undefined;
        var schemeCodeSet = new Set();
        z.transactionModeList.map(function (transactionMode) {
            var transactionTypeListCopy = transactionMode.transactionTypeList.map(function (transactionType) {
                var freqListCopy = transactionType.freqList.map(function (freq) {
                    if (freq.schemeGroupCode) {
                        schemeCodeSet.add(freq.schemeGroupCode);
                    }
                    return __assign({}, freq);
                });
                return __assign(__assign({}, transactionType), { freqList: freqListCopy });
            });
            return __assign(__assign({}, transactionMode), { transactionTypeList: transactionTypeListCopy });
        });
        z.transactionModeList[index].transactionTypeList.map(function (z) {
            switch (z.trxType) {
                case "XSIP":
                    sipData = {};
                    var firstSipFlagSet_1 = false;
                    z.freqList.map(function (f) {
                        if (f.frequency === "MONTHLY") {
                            sipFrequency.unshift({
                                title: f.dpFrequency,
                                value: f.frequency,
                            });
                        }
                        else {
                            sipFrequency.push({
                                title: f.dpFrequency,
                                value: f.frequency,
                            });
                        }
                        sipData[f.frequency] = f;
                        if (!firstSipFlagSet_1) {
                            sipFlag = f.sipFlag === "Y";
                            firstSipFlagSet_1 = true;
                        }
                    });
                    break;
                case "SWP":
                    z.freqList.map(function (w) {
                        if (w.frequency === "MONTHLY") {
                            swpData = {};
                            swpData[w.frequency] = w;
                        }
                        swpFlag = w.swpFlag === "Y";
                    });
                    break;
                case "STP":
                    z.freqList.map(function (w) {
                        if (w.frequency === "MONTHLY") {
                            stpData = {};
                            stpData[w.frequency] = w;
                        }
                        stpFlag = w.stpFlag === "Y";
                    });
                    break;
                case "REDEMPTION":
                    z.freqList.map(function (w) {
                        if (w === null || w === void 0 ? void 0 : w.frequency) {
                            redeemData = {};
                            redeemData["MONTHLY"] = w;
                        }
                        redeemFlag = (w === null || w === void 0 ? void 0 : w.redeemFlag) === "Y";
                    });
                    break;
                case "LUMPSUM":
                    z.freqList.map(function (w) {
                        if (w.frequency === "MONTHLY") {
                            lumpsumData = {};
                            lumpsumData[w.frequency] = w;
                        }
                        lumpsumFlag = w.lumpsumFlag === "Y";
                    });
                    break;
                case "SWITCH":
                    z.freqList.map(function (w) {
                        if (w.frequency === "MONTHLY") {
                            switchData = {};
                            switchData[w.frequency] = w;
                        }
                        switchFlag = w.switchFlag === "Y";
                    });
                    break;
            }
        });
        if (trxType === EInvestmentType.SWITCH) {
            // 'switch from' transaction type passed is REdeem hence reassignenng STP data because switch shares common function with stp
            stpData = redeemData;
            stpFlag = ((_a = redeemData === null || redeemData === void 0 ? void 0 : redeemData["MONTHLY"]) === null || _a === void 0 ? void 0 : _a.redeemFlag) === "Y";
        }
        return __assign(__assign({}, z), { lumpsumFlag: lumpsumFlag, redeemFlag: redeemFlag, sipFlag: sipFlag, swpFlag: swpFlag, stpFlag: stpFlag, switchFlag: switchFlag, transactionMode: transactionMode, sipFrequency: sipFrequency, sipData: sipData, redeemData: redeemData, swpData: swpData, stpData: stpData, schemeCodeList: Array.from(schemeCodeSet), reInvFlag: z.divReFlag, schemeListKey: "".concat(z.returnType).concat(z.divFreq ? "#".concat(z.divFreq) : ""), lumpsumData: lumpsumData });
    });
};
var TocSchemeDetailMapper = function (response, trxType) {
    if (!response || !response.data || !response.data.schemePlanList) {
        return null;
    }
    var schemePlanListing = [];
    var schemPlanArr = response.data.schemePlanList.map(function (item) {
        schemePlanListing.push({
            label: getSchemePlanName(item.schemePlan),
            value: getSchemePlanName(item.schemePlan),
        });
        var returnOption = [];
        var divFrequency = {};
        var returnTypeList = flattenArray(item.returnTypeList.map(function (returnType) {
            returnOption.push({
                label: returnType.returnType,
                value: returnType.returnType,
            });
            divFrequency[returnType.returnType] = returnType.divFrequencyList.map(function (z) {
                return {
                    label: z.divFreq,
                    value: "".concat(z.returnType).concat(z.divFreq ? "#".concat(z.divFreq) : ""),
                };
            });
            // }
            return divFrequencyMapper(returnType.divFrequencyList, trxType);
        }));
        return {
            shmplan: getSchemePlanName(item.schemePlan),
            returnOption: returnOption,
            divFrequency: divFrequency,
            returnTypeList: returnTypeList,
            groupCode: response.data.groupCode,
        };
    });
    return {
        schemePlanListing: schemePlanListing,
        groupCode: response.data.groupCode,
        schemePlanList: schemPlanArr,
    };
    // return {
    //   groupCode: response.data.groupCode,
    //   dd, // Array of shmplan-based grouped data
    // };
};
export default TocSchemeDetailMapper;
var getSchemePlanName = function (schemePlan) {
    var schemenameChanged;
    if (schemePlan === EMFSchemesPlanType2.NORMAL)
        schemenameChanged = MFSchemesPlanTypes.REGULAR;
    else
        schemenameChanged = MFSchemesPlanTypes.DIRECT;
    return schemenameChanged;
};
